import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { CompteService } from '@service/syndic/compte.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-compte-add',
  templateUrl: './compte-add.component.html',
  styleUrls: ['./compte-add.component.scss']
})
export class CompteAddComponent implements OnInit {
  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  compte: any;
  title: string = '';

  types = [
    { label: 'Banque', value: 'BANQUE' },
    { label: 'Caisse', value: 'CAISSE' }
  ];

  statuts = [
    { label: 'Actif', value: 'ACTIF' },
    { label: 'Inactif', value: 'INACTIF' },
    { label: 'Clôturé', value: 'CLOTURE' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private compteService: CompteService,
    private syndicService: SyndicService
  ) {
    this.edit = this.compteService.edit;
    this.compte = this.compteService.getCompte();
    const lib = this.compte ? this.compte.libelle : '';
    this.title = (!this.edit) ? 'Ajouter un compte' : 'Modifier le compte ' + lib;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.compte) { this.setFormValue(); }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      libelle: [null, [Validators.required]],
      numero: [null],
      type: ['BANQUE', [Validators.required]],
      banque: [null],
      iban: [null],
      soldeInitial: [0],
      statut: ['ACTIF'],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.compte.uuid,
      libelle: this.compte.libelle,
      numero: this.compte.numero,
      type: this.compte.type,
      banque: this.compte.banque,
      iban: this.compte.iban,
      soldeInitial: this.compte.soldeInitial,
      statut: this.compte.statut,
      trustee: this.compte.trustee?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.compteService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'COMPTE_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'COMPTE_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void { this.modal.close('ferme'); }
  get f() { return this.form.controls; }
}
